import React from 'react';
import styled from '@emotion/styled';
import KvTitleSpImg from 'ui/images/top_for_buyer/kv_title_sp.svg';
import KvTitlePcImg from 'ui/images/top_for_buyer/kv_title_pc.svg';
import SignUpButtonPcImg from 'ui/images/top_for_buyer/sign_up_button_pc.svg';
import SignUpButtonSpImg from 'ui/images/top_for_buyer/sign_up_button_sp.svg';
import { mqMin } from 'utils/responsive';
import { useNavigate } from 'react-router-dom';
import { Only } from 'ui/components/elements/Only/Only';

const Container = styled.div`
    display: flex;
    justify-content: center;
    margin: 0 auto;

    ${mqMin('NARROW')} {
        min-height: 30.5rem;
    }
`;

const H2 = styled.h2`
    width: 18.6rem;
    margin: 3rem auto 0 auto;
    animation: kvFadein 0.5s linear 1.6s forwards;
    opacity: 0;

    img {
        width: 100%;
        height: auto;
    }

    ${mqMin('SP')} {
        width: 23.6rem;
        margin: 2rem auto 0 auto;
    }

    ${mqMin('NARROW')} {
        top: 2.5rem;
        left: 50%;
        margin: 0 auto;
        transform: translateX(-50%);
        position: absolute;
        width: 50.45rem;
        animation: kvFadein 0.5s linear 1.6s forwards;
    }
`;

const LinkContainer = styled.div`
    opacity: 0;
    position: absolute;
    display: block;
    left: 50%;
    z-index: 10;
    bottom: 2rem;
    transform: translateX(-50%);
    width: 20.4rem;
    justify-content: center;
    overflow: visible;
    animation: kvFadein 0.5s linear 1.6s forwards;
    pointer-events: auto;
    cursor: pointer;
    &:hover {
        transform: translateX(-50%) scale(1.01);
        transition: transform 0.2s ease-in-out;
    }

    ${mqMin('SP')} {
        width: 30rem;
        bottom: 4rem;
    }

    ${mqMin('NARROW')} {
        width: 43.13rem;
        position: absolute;
        bottom: 2rem;
        display: flex;
        overflow: hidden;
        pointer-events: auto;
        animation: kvFadein 0.4s linear 2.2s forwards;

        a::before {
            animation: kvBtn 1s ease-in-out 2.6s;
        }
    }
    img {
        width: 100%;
        height: auto;
        max-width: initial;
    }
`;

export const KvMainText: React.FC = () => {
    const navigate = useNavigate();

    const goToRegister = () => {
        navigate('/buyer/send-registration-mail/');
    };
    return (
        <Container>
            <H2>
                <picture>
                    <source media="(max-width: 1023px)" srcSet={KvTitleSpImg} />
                    <source media="(min-width: 1024px)" srcSet={KvTitlePcImg} />
                    <img src={KvTitlePcImg} alt="買いたい会社が決まってる？適切な仲介会社と出会えます" />
                </picture>
            </H2>

            <LinkContainer onClick={goToRegister}>
                <Only pc>
                    <img src={SignUpButtonPcImg} alt="買い手企業の登録はこちら" />
                </Only>
                <Only sp>
                    <img src={SignUpButtonSpImg} alt="買い手企業の登録はこちら" />
                </Only>
            </LinkContainer>
        </Container>
    );
};
